<div class="container-fluid py-4 px-2">

  <div class="text-white rounded-3 shadow-sm p-3 mb-4" style="background-color: #1e3a8a;">

    <h2 class="h4 mb-0 fw-bold">
      Búsqueda de Artículos
    </h2>

  </div>

  <form [formGroup]="searchForm" (ngSubmit)="onSearch()" class="row g-2 mb-4">
    <div class="col-12 col-md-6 col-lg-5">
      <input type="text" formControlName="term" class="form-control form-control-lg shadow-sm"
        placeholder="Buscar por código INE o nombre del artículo..." />
    </div>

    <div class="col-12 col-md-3 col-lg-2">
      <select class="form-select form-select-lg shadow-sm" formControlName="estado" data-bs-toggle="tooltip"
        data-bs-placement="top" title="Filtra los artículos por estado">
        <option value="TODOS">Todos los estados</option>
        <option value="A">Activos</option>
        <option value="I">Inactivos</option>
        <option value="P">Pendientes</option>
      </select>
    </div>

    <div class="col-12 col-md-3 col-lg-3">
      <select class="form-select form-select-lg shadow-sm" formControlName="variedad" data-bs-toggle="tooltip"
        data-bs-placement="top" title="Selecciona la variedad a trabajar">
        <option [ngValue]="0">Todas las variedades</option>

        @for (variedad of variedades(); track variedad.codigo) {
        <option [ngValue]="variedad.codigo">
          {{ variedad.nombre }}
        </option>
        }
      </select>
    </div>

    <div class="col-12 col-lg-auto d-flex flex-wrap gap-2">
      <button type="submit" class="btn btn-info text-white btn-lg px-4 shadow-sm" data-bs-toggle="tooltip"
        data-bs-placement="top" title="Busca artículos por código INE, nombre, estado y variedad">
        <i class="bi bi-search"></i> Buscar
      </button>

      <button type="button" class="btn btn-info btn-lg text-white px-4 shadow-sm" (click)="onClear()"
        data-bs-toggle="tooltip" data-bs-placement="top" title="Limpia la búsqueda y reinicia los filtros">
        <i class="bi bi-eraser"></i> Limpiar
      </button>
    </div>
  </form>

  @if (loading()) {
  <div class="text-center py-3 text-primary fw-semibold">
    <div class="spinner-border me-2"></div>
    Cargando artículos...
  </div>
  }

  @if (error()) {
  <div class="alert alert-danger text-center">{{ error() }}</div>
  }

  @if (hasSearched() && !loading() && articles().length === 0) {
  <div class="alert alert-warning text-center">
    <i class="bi bi-exclamation-circle"></i> No se encontraron resultados.
  </div>
  }
  <app-export-articles-excel [articles]="articles()" [secciones]="secciones()" [divisiones]="divisiones()"
    [clases]="clases()" [productos]="productos()" [variedades]="variedades()">
  </app-export-articles-excel>


  @if (articles().length > 0) {
  <div class="ag-theme-quartz shadow-sm rounded-3" style="height: 500px; width: 100%;">

    <ag-grid-angular style="width: 100%; height: 100%;" [rowData]="articles()" [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef" [pagination]="true" [paginationPageSize]="10" [animateRows]="true"
      (cellClicked)="onCellClicked($event)">
    </ag-grid-angular>

  </div>
  }

</div>

<app-model-edit-article [article]="selectedArticle" (deleted)="onArticleDeleted($event)"
  (updated)="onArticleUpdated($event)">
</app-model-edit-article>